import SvgIcon from '@components/svg-icon/svg-icon'
import React from 'react'
import styleable from 'react-styleable';

import { Info } from '@helpers/icon-dictionary';
import css from './due-date-info-icon.scss';

const DueDateInfoIcon = () => (
  <SvgIcon icon={Info} className={css.dueDateInfoIcon} />
)

export default styleable(css)(DueDateInfoIcon);


// WEBPACK FOOTER //
// ./components/current-assignment-modal/assign-list/assignment/components/due-date-info/components/due-date-info-icon.js